const ROUTE_ANNOUNCEMENTS = '/announcements';

const ROUTE_REDESIGN_APP_ADMIN = '/app-admin';
const ROUTE_REDESIGN_USER_ADMIN = '/user-admin-redesign';

const ROUTE_REDESIGN_HEALTH_CHECKS = '/health_checks';

const ROUTE_ACCOUNT_ADMIN = `/account-admin`;
const ROUTE_ACCOUNT_ADMIN_REGISTRATION_MATERIALS = `${ROUTE_ACCOUNT_ADMIN}/registration-materials`;
const ROUTE_BILLING = '/billing';
const ROUTE_BILLING_DETAILS = `${ROUTE_BILLING}/details`;
const ROUTE_COMMERCIAL_LINES_QUOTING = '/commercial-lines-quoting';
const ROUTE_CL_PRODUCT_DETAIL = `${ROUTE_COMMERCIAL_LINES_QUOTING}/product-detail`;
const ROUTE_CLAIMS = '/claims';
const ROUTE_CLIENTS = '/clients';
const ROUTE_DASH = '/dash';
const ROUTE_DASHBOARD = '/dashboard';
const ROUTE_EXTERNAL = '/external';
const ROUTE_EMPLOYEE_HOME = '/home';
const ROUTE_NEWS_ARTICLE_ADMIN = '/news-admin';

const ROUTE_QUOTES = '/quotes';
const ROUTE_FIND_AN_AGENT = '/find-an-agent';
const ROUTE_RUNTIME_CONFIG = '/runtime-config';
const ROUTE_R_ANNOUNCEMENTS = `${ROUTE_DASH}${ROUTE_ANNOUNCEMENTS}`;
const ROUTE_WILDCARD = '/*';

const ROUTE_REDESIGN_HOME_PAYMENT_BALANCE = `${ROUTE_EMPLOYEE_HOME}/payment-balance`;
const ROUTE_REDESIGN_HOME_PAYMENT_HISTORY = `${ROUTE_EMPLOYEE_HOME}/payment-history`;
const ROUTE_REDESIGN_HOME_MANAGE_CURRENT_PAYMENT = `${ROUTE_EMPLOYEE_HOME}/manage-payment`;
const ROUTE_REDESIGN_REPORTS = '/reports';
const ROUTE_REDESIGN_REPORTS_BOOK_MANAGEMENT = `${ROUTE_REDESIGN_REPORTS}/book-management`;
const ROUTE_REDESIGN_REPORTS_AGENT_ABSREPORTS = `${ROUTE_REDESIGN_REPORTS}/absreports`;
const ROUTE_REDESIGN_REPORTS_AGENT_APNEREPORT = `${ROUTE_REDESIGN_REPORTS}/apnereport`;
const ROUTE_REDESIGN_REPORTS_AGENT_LOSSESBYAGENTREPORTS = `${ROUTE_REDESIGN_REPORTS}/lbareports`;
const ROUTE_REDESIGN_REPORTS_AGENT_PLRREPORTS = `${ROUTE_REDESIGN_REPORTS}/plrreports`;
const ROUTE_REDESIGN_REPORTS_BILLING_TAR = `${ROUTE_REDESIGN_REPORTS}/tareports`;
const ROUTE_REDESIGN_REPORTS_BILLING_PAYMENT_BALANCE_REPORT = `${ROUTE_REDESIGN_REPORTS}/pbreports`;
const ROUTE_REDESIGN_REPORTS_BILLING_PAYMENTS_MADE_REPORT = `${ROUTE_REDESIGN_REPORTS}/pmreports`;
const ROUTE_REDESIGN_REPORTS_BILLING_PAYMENTS_DUE = `${ROUTE_REDESIGN_REPORTS}/payment-due`;
const ROUTE_REDESIGN_REPORTS_DIRECT_BILL_COMISSION = `${ROUTE_REDESIGN_REPORTS}/dbcreports`;
const ROUTE_REDESIGN_RESOURCES = '/resources';
const ROUTE_REDESIGN_RESOURCES_MARKETING = `${ROUTE_REDESIGN_RESOURCES}/marketing`;
const ROUTE_REDESIGN_RESOURCES_TRAINING = `${ROUTE_REDESIGN_RESOURCES}/training`;
const ROUTE_REDESIGN_RESOURCES_UNDERWRITING = `${ROUTE_REDESIGN_RESOURCES}/underwriting`;
const ROUTE_REDESIGN_RESOURCES_STORM = `${ROUTE_REDESIGN_RESOURCES}/storm`;

export {
  ROUTE_ACCOUNT_ADMIN,
  ROUTE_ACCOUNT_ADMIN_REGISTRATION_MATERIALS,
  ROUTE_BILLING,
  ROUTE_BILLING_DETAILS,
  ROUTE_CL_PRODUCT_DETAIL,
  ROUTE_CLAIMS,
  ROUTE_CLIENTS,
  ROUTE_DASH,
  ROUTE_DASHBOARD,
  ROUTE_EMPLOYEE_HOME,
  ROUTE_EXTERNAL,
  ROUTE_FIND_AN_AGENT,
  ROUTE_NEWS_ARTICLE_ADMIN,
  ROUTE_QUOTES,
  ROUTE_R_ANNOUNCEMENTS,
  ROUTE_REDESIGN_APP_ADMIN,
  ROUTE_REDESIGN_HEALTH_CHECKS,
  ROUTE_REDESIGN_HOME_MANAGE_CURRENT_PAYMENT,
  ROUTE_REDESIGN_HOME_PAYMENT_BALANCE,
  ROUTE_REDESIGN_HOME_PAYMENT_HISTORY,
  ROUTE_REDESIGN_REPORTS,
  ROUTE_REDESIGN_REPORTS_AGENT_ABSREPORTS,
  ROUTE_REDESIGN_REPORTS_AGENT_APNEREPORT,
  ROUTE_REDESIGN_REPORTS_AGENT_LOSSESBYAGENTREPORTS,
  ROUTE_REDESIGN_REPORTS_AGENT_PLRREPORTS,
  ROUTE_REDESIGN_REPORTS_BILLING_PAYMENT_BALANCE_REPORT,
  ROUTE_REDESIGN_REPORTS_BILLING_PAYMENTS_DUE,
  ROUTE_REDESIGN_REPORTS_BILLING_PAYMENTS_MADE_REPORT,
  ROUTE_REDESIGN_REPORTS_BILLING_TAR,
  ROUTE_REDESIGN_REPORTS_BOOK_MANAGEMENT,
  ROUTE_REDESIGN_REPORTS_DIRECT_BILL_COMISSION,
  ROUTE_REDESIGN_RESOURCES,
  ROUTE_REDESIGN_RESOURCES_MARKETING,
  ROUTE_REDESIGN_RESOURCES_STORM,
  ROUTE_REDESIGN_RESOURCES_TRAINING,
  ROUTE_REDESIGN_RESOURCES_UNDERWRITING,
  ROUTE_REDESIGN_USER_ADMIN,
  ROUTE_RUNTIME_CONFIG,
  ROUTE_WILDCARD,
};
